import React, { Component } from 'react'
import { connect } from 'react-redux'

import classnames from 'classnames';


class Finances extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // FinancialsLeftData:['market_currency_hkd','market_deadline','market_eps','market_net_asset_value_per_share','market_debt_ratio','market_return_on_equity','market_return_on_assets','market_current_ratio','market_quick_ratio','market_inventory_turnover','market_operating_profit_ratio','market_earning_before_tax_ratio'],
        }
    }
    render() {
        const { language, Data,leftData ,headData,blockSelectIndex} = this.props
        return (
            <div>
                <div className='headData'>
                {/* { headData  &&   <div className={blockSelectIndex == 0?'no_en_finances_black_block' :blockSelectIndex == 1 ?'no_en_income_black_block' : blockSelectIndex == 2 ? 'no_en_blance_sheet_black_block' :'no_en_cash_flow_statement_black_block'}>{language.market_currency_hkd} </div>} */}
                { Data?.length != 0  &&   <div className={classnames(this.handleHKDclassNmae())}>{language.market_currency_hkd} </div>}
                    <div className='headData_data'  id='headData_data' onScroll={()=> this.handleHeadData_dataScroll()} >
                        {   headData && headData.map((item,index)=>{
                    return ( <div  className='headData_data_item' key={item} >{item} </div>  )
                })}
                    </div>
                </div>
               
               <div>
               { Data?.length != 0 && <div className='table'>
                    {/* table_left */}
                    <div className='table_left'>
                        { leftData &&leftData.map((item,index)=>{
                            return (<div key={item} className={this.props.handleLeftClassName(index)} > {language[item]} </div>)
                        })}
                    </div>
                    {/* table_data */}
                    <div className='table_data' id='table_data' onScroll={ () => this.handleTable_dataScroll()} >
                        { Data &&  Data.map((item,index)=>{
                            return (<div key={index} className='table_data_one'>
                                        {item?.map((itemdata,indexdata)=>{
                                            if(indexdata == 0) return ''
                                          else { return   (<div key={indexdata} className={this.props.handleDataClassName(indexdata)} > {itemdata ? itemdata : '-'} </div>)}
                                        })}
                                    </div>)
                        })}
                    </div>
                </div>}
                 { Data?.length == 0   &&<div className='no_data'>{language.common_no_data}</div>} 
                 <div style={{padding:"20px 0px 20px 20px",fontSize:"14px"}}>{language.market_accounting_standards} </div>
            </div>  
            </div>
           
        )
    }
    handleHKDclassNmae = () =>{
        const {language} = this.props
        if(language.key != 'EN'){
            switch(this.props.blockSelectIndex){
                case 0: return 'no_en_finances_black_block'
                case 1: return 'no_en_income_black_block'
                case 2: return 'no_en_blance_sheet_black_block'
                case 3: return 'no_en_cash_flow_statement_black_block'
            }
        }else {
            switch(this.props.blockSelectIndex){
                case 0: return 'finances_black_block'
                case 1: return 'income_black_block'
                case 2: return 'blance_sheet_black_block'
                case 3: return 'cash_flow_statement_black_block'
            }
            }
        // switch(this.props.blockSelectIndex){
        //         case 0:
        //             if(language.key != 'EN'){
        //                 return 'no_en_finances_black_block'
        //             }else return 'finances_black_block'
        //         case 1:
        //             if(language.key != 'EN'){
        //                 return 'no_en_income_black_block'
        //             }else return 'income_black_block'
        //         case 2:
        //             if(language.key != 'EN'){
        //                 return 'no_en_blance_sheet_black_block'
        //             }else return 'blance_sheet_black_block'
        //         case 3:
        //             if(language.key != 'EN'){
        //                 return 'no_en_cash_flow_statement_black_block'
        //             }else return 'cash_flow_statement_black_block'
        // }
    }
    handleHeadData_dataScroll = () =>{
        if(document.getElementById('table_data') && document.getElementById('headData_data'))
        document.getElementById('table_data').scrollLeft = document.getElementById('headData_data').scrollLeft
    }
    handleTable_dataScroll = () =>{
        if(document.getElementById('table_data') && document.getElementById('headData_data'))
        document.getElementById('headData_data').scrollLeft = document.getElementById('table_data').scrollLeft
    }

}



export default connect(state => ({
    language: state.app.language,
}), dispatch => ({
    
}) )(Finances)